import styled from 'styled-components';
import config from '../config';
import { Link } from 'gatsby';

const Item = styled.section`
  width: calc(50% - 1.6rem);

  & > p {
    color: ${config.palette.darkBlueTransparent('0.6')};
    margin: 1.4rem 0;
  }
`;

const ReadMoreLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;

  & > b {
    display: block;
    color: ${config.palette.lightBlue};
    margin-right: 0.8rem;
  }
`;

export { Item, ReadMoreLink };
